import type { OrganizationDetail } from '@viewer/protocol';
import styles from './org.module.css';

interface Props {
  org: OrganizationDetail;
  onOpen(tab: 'devices' | 'groups' | 'members'): void;
}

export function OverviewTab({ org, onOpen }: Props) {
  const stats: Array<{ value: number | string; label: string; tab?: 'devices' | 'groups' | 'members' }> = [
    { value: `${org.counts.devicesOnline} / ${org.counts.devices}`, label: 'computadores online', tab: 'devices' },
    { value: org.counts.groups, label: 'grupos', tab: 'groups' },
    { value: org.counts.members, label: 'colaboradores', tab: 'members' },
  ];

  return (
    <>
      <div className={styles.stats}>
        {stats.map((s) => (
          <button
            key={s.label}
            type="button"
            className={styles.stat}
            style={{ textAlign: 'left', cursor: 'pointer', color: 'inherit' }}
            onClick={() => s.tab && onOpen(s.tab)}
          >
            <p className={styles.statValue}>{s.value}</p>
            <p className={styles.statLabel}>{s.label}</p>
          </button>
        ))}
      </div>
      <section className={styles.panel}>
        <h2 className={styles.panelTitle}>Como funciona</h2>
        <p className={styles.help}>
          Os computadores pertencem à empresa, não às pessoas. Vincule cada computador com um código gerado em
          Dispositivos, organize-os em Grupos e, em Colaboradores, defina a quais grupos cada pessoa tem acesso e o
          que ela pode fazer. Ninguém entra num computador da empresa só por saber o ID dele.
        </p>
      </section>
    </>
  );
}
